import React, { useEffect, useState } from "react";
import { Col, Form, Row, Stack } from "react-bootstrap";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import CardWithChart from "../../../components/CardWithChart";
import { useDispatch, useSelector } from "react-redux";
import ValidationSchema from "../../../components/Common/ValidationSchema";
import { useFormik } from "formik";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { fetchReportsData } from "../../../redux/slice/AddToReportSlice";
import CardWithChartComp from "../../../components/CardWithChartComp";
import CardWithLineChart from "../../../components/CardWithLineChart";
import { fetchDashboardListingData } from "../../../redux/slice/DashboardListingSlice";
import { toast } from "react-toastify";
import { usePic } from "../../../context/PicProvider";
import {
  createNewReport,
  fetchReportListDataById,
  updateReportListDetails,
} from "../../../redux/slice/ReportsSlice";
// import StackedBarChart from "../../../components/StackedBarChart";
import CustomCheckbox from "../../../components/CustomCheckbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomAutocomplete from "../../../components/Common/MUI/CustomAutocomplete";
import DisableIcon from "../../../Assets/svg/disable-icon.svg";
import TrashIcon from "../../../Assets/svg/trash-icon.svg";
import KitInstalledChart from "../../../components/KitInstalledChart";
import { reportWidgetName } from "../../../utils/constants";
import moment from "moment";

const ReportEditor = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const initialValues = {
    report_name: "",
    // group_member: null,
    start_on: "",
    frequency_units: "",
    how_often: "",
    send_to_group: [],
    send_to_user: [],
  };
  const { AddReportData } = useSelector((state) => state.REPORTSDATA);
  const [search, setSearch] = useState(null);
  const [nameData, setNameData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [manageButton, setManageButton] = useState();
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [userGroupList, setUserGroupList] = useState([]);
  const [widgets, setWidgets] = useState([]);
  const { DashboardListingData } = useSelector(
    (state) => state.DASHBOARDLISTING
  );
  const { setIsLoading } = usePic();

  const {
    values,
    handleBlur,
    handleChange,
    setValues,
    errors,
    touched,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.createNewReport,
    onSubmit: async (values, { setSubmitting }) => {
      if (
        ["monthly", "weekly", "bi_weekly"].includes(values.frequency_units) &&
        !values.how_often
      ) {
        toast.error("*How Often is required");
      } else if (widgets.length === 0) {
        toast.error("*At least one widget must be selected");
      } else {
        setIsLoading(true);
        let res;
        try {
          const payload = {
            ...values,
            report_widget_name: widgets,
          };
          if (id) {
            // Call update if id is present
            res = await dispatch(updateReportListDetails({ ...payload, id }));
          } else {
            // Call create if id is not present
            res = await dispatch(createNewReport(payload));
          }

          if (res.payload?.status === 200) {
            navigate("/reports");
          }
        } catch (error) {
          console.error("Error:", error);
        } finally {
          setSubmitting(false);
          setIsLoading(false);
        }
      }
    },
  });

  useEffect(() => {
    dispatch(fetchReportsData());
    const fetchData = async () => {
      try {
        await dispatch(fetchDashboardListingData());
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchData();
  }, []);

  const addToReport = () => {
    if (selectedUser) {
      const findUser = nameData.find(
        (user) => user.user_id === selectedUser.user_id
      );
      if (findUser) {
        toast.error("User already selected");
      } else {
        addGroupHandler(selectedUser, "user");
      }
    } else if (selectedGroup) {
      const findGroup = nameData.find(
        (user) => user.group_id === selectedGroup.group_id
      );
      if (findGroup) {
        toast.error("Group already selected");
      } else {
        addGroupHandler(selectedGroup, "group");
      }
    } else {
      toast.error("Please search and select group or user");
    }
  };

  const getNameDataFromList = (data) => {
    let type = "user";
    if (data.group_name) {
      type = "group";
    }
    setSearch(data);
    if (type === "user") {
      const selectedUser = {
        user_id: data._id,
        full_name: `${data.first_name} ${data.last_name}`,
      };
      setSelectedUser(selectedUser);
      setSelectedGroup(null);
    } else if (type === "group") {
      const selectedGroup = {
        group_id: data._id,
        group_name: data.group_name,
      };
      setSelectedGroup(selectedGroup);
      setSelectedUser(null);
    }
  };

  const addGroupHandler = (data, type, search) => {
    if (!data || Object.keys(data).length === 0) {
      return;
    }

    let newData = null;

    if (type === "user") {
      newData = {
        user_id: data.user_id,
        full_name: data.full_name,
      };
    } else if (type === "group") {
      newData = {
        group_id: data.group_id,
        group_name: data.group_name,
      };
    }

    // Add the new data to the respective array based on the type
    if (type === "user") {
      setValues((prevValues) => ({
        ...prevValues,
        send_to_user: [...prevValues.send_to_user, newData],
      }));
    } else if (type === "group") {
      setValues((prevValues) => ({
        ...prevValues,
        send_to_group: [...prevValues.send_to_group, newData],
      }));
    }

    // Update the nameData state to include the new data
    setNameData((prev) => [...prev, newData]);
    setSearch(null);
    setSelectedUser(null);
    setSelectedGroup(null);
  };

  const removeGroup = (groupId, isUser) => {
    const filterName = nameData.filter((curElm) => {
      if (isUser) {
        return curElm.user_id !== groupId;
      } else {
        return curElm.group_id !== groupId;
      }
    });

    setNameData(filterName);

    if (isUser) {
      setValues((prevValues) => ({
        ...prevValues,
        send_to_user: filterName,
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        send_to_group: filterName,
      }));
    }
  };

  const renderFrequencyOptions = () => {
    const frequencies = [
      { label: "Repeat daily", value: "daily" },
      { label: "Repeat weekly", value: "weekly" },
      { label: "Repeat bi-weekly", value: "bi_weekly" },
      { label: "Repeat monthly", value: "monthly" },
      { label: "Repeat quarterly", value: "quarterly" },
      { label: "Repeat every six months", value: "semi_annually" },
      { label: "Repeat annually", value: "annually" },
    ];

    return frequencies.map((frequency) => (
      <option key={frequency.value} value={frequency.value}>
        {frequency.label}
      </option>
    ));
  };

  useEffect(() => {
    const users = AddReportData?.data?.Users ?? [];
    const groupList = AddReportData?.data?.report_group_list ?? [];
    setUserGroupList([...users, ...groupList]);
  }, [AddReportData]);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await dispatch(fetchReportListDataById(id));
          const reportData = response.payload?.data;
          setValues({
            report_name: reportData.report_name,
            ...(reportData?.start_on && {
              start_on: moment(reportData.start_on).format("YYYY-MM-DD"),
            }),

            frequency_units: reportData.frequency_units,
            how_often: reportData?.how_often ?? "",
            send_to_group: reportData.send_to_group,
            send_to_user: reportData.send_to_user,
          });
          setNameData(reportData.send_to_user);
          setWidgets(reportData?.report_widget_name ?? []);
        } catch (error) {
          console.error("Error fetching report data:", error);
        }
      };
      fetchData();
    }
  }, [dispatch, id, setValues]);

  const handleSelectWidget = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setWidgets((prev) => [...prev, name]);
    } else {
      setWidgets((prev) => {
        const filteredData = [...prev].filter((item) => item !== name);
        return filteredData;
      });
    }
  };
  const handleSelectAllWidget = (e) => {
    const { checked } = e.target;
    if (checked) {
      setWidgets(reportWidgetName);
    } else {
      setWidgets([]);
    }
  };

  const widgetPartialChecked = () => {
    if (widgets.length === reportWidgetName.length) {
      return false;
    } else if (widgets.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Stack className="flex-grow-1 bg-white popup-layout">
      <div
        className="position-sticky bg-white header-section"
        style={{ zIndex: 1002 }}
      >
        <h4 className="text-center fw-bold m-0">
          {id && "Update "}Report Editor
        </h4>
        <hr className="my-3 my-md-4" />
      </div>
      <Form onSubmit={handleSubmit} className="d-flex flex-column flex-grow-1">
        <div className="row row-gap-3 pt-3 flex-grow-1">
          <div className="col-md-5">
            <Form.Group className="mb-3" controlId="formReportName">
              <Form.Control
                type="text"
                name="report_name"
                value={values.report_name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Report Name"
              />
              {errors.report_name && touched.report_name && (
                <p className="text-danger mt-1 mb-0">{errors.report_name} </p>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicDate">
              <h6>Start on </h6>
              <Form.Control
                type="date"
                name="start_on"
                value={values.start_on}
                onChange={handleChange}
                min={todayDate}
              />
              {errors.start_on && touched.start_on && (
                <p className="text-danger mt-1 mb-0">{errors.start_on} </p>
              )}
            </Form.Group>
            <div className="mb-3">
              <h6>Frequency</h6>
              <Row className="row-gap-3">
                <Col md={6}>
                  <Form.Group controlId="exampleForm.ControlFrequencyUnits">
                    <Form.Select
                      aria-label="Choose Frequency"
                      name="frequency_units"
                      value={values.frequency_units}
                      onChange={handleChange}
                    >
                      <option value="" disabled className="option-title">
                        Choose Units
                      </option>
                      {renderFrequencyOptions()}
                    </Form.Select>
                    {errors.frequency_units && touched.frequency_units && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.frequency_units}
                      </p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  {values.frequency_units === "monthly" && (
                    <Form.Group controlId="exampleForm.ControlMonthly">
                      <Form.Select
                        name="how_often"
                        value={values.how_often}
                        onChange={handleChange}
                      >
                        <option Choose How Oftenoption value="" disabled>
                          Choose How Often
                        </option>
                        <option value="start_of_month">
                          Beginning of the Month
                        </option>
                        <option value="end_of_month">End of the Month</option>
                      </Form.Select>
                    </Form.Group>
                  )}
                  {(values.frequency_units === "weekly" ||
                    values.frequency_units === "bi_weekly") && (
                    <Form.Group controlId="exampleForm.ControlWeekly">
                      <Form.Select
                        name="how_often"
                        value={values.how_often}
                        onChange={handleChange}
                      >
                        <option value="" disabled className="option-title">
                          Choose How Often
                        </option>
                        <option value="monday">Monday</option>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                      </Form.Select>
                    </Form.Group>
                  )}
                </Col>
              </Row>
            </div>
            <div>
              <h6>Send Report To</h6>
              <div className="d-flex flex-column flex-xl-row align-items-xl-center gap-3 mb-3">
                <CustomAutocomplete
                  value={search}
                  onValueChange={(value) => getNameDataFromList(value)}
                  textProps={{
                    placeholder: "Search",
                    variant: "outlined",
                    name: "personOfTreatment",
                  }}
                  autoCompleteProps={{ disableClearable: true }}
                  options={userGroupList}
                  showEndAdornment={false}
                  noOptionsText="No group options"
                  getOptionLabel={(option) => {
                    return option.group_name
                      ? option.group_name
                      : `${option.first_name || ""} ${
                          option.last_name || ""
                        }`.trim();
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option?._id === value?._id
                  }
                  sx={{}}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={addToReport}
                >
                  Add to Report
                </button>
              </div>
            </div>
            <hr />
            {nameData.length > 0 && (
              <div className="d-flex gap-3 flex-wrap">
                {nameData.map((curElm, index) => (
                  <div className="position-relative" key={index}>
                    <button
                      className={`w-100 border btn ${
                        manageButton === index + 1
                          ? "border-primary text-primary"
                          : "text-black-50"
                      }`}
                      type="button"
                      onClick={() => setManageButton(index + 1)}
                    >
                      {/* Display full name if it exists, otherwise display group name */}
                      {curElm.full_name ? curElm.full_name : curElm.group_name}
                    </button>
                    {manageButton === index + 1 && (
                      <span
                        className={`close-button-span ${
                          manageButton === index + 1 ? "text-primary" : ""
                        }`}
                      >
                        <IoIosCloseCircleOutline
                          className="cursor text_gray"
                          onClick={() =>
                            removeGroup(
                              curElm.user_id || curElm.group_id,
                              !!curElm.user_id
                            )
                          }
                          size={25}
                        />
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
            {errors.send_to_user && touched.send_to_user && (
              <p className="text-danger mt-1 mb-0">{errors.send_to_user}</p>
            )}
            {errors.send_to_group && touched.send_to_group && (
              <p className="text-danger mt-1 mb-0">{errors.send_to_group}</p>
            )}
            <hr className="d-md-none" />
          </div>
          <div className="col-md-1 d-none d-md-flex">
            <Stack className="align-items-center">
              <div
                style={{
                  width: "1px",
                  height: "1px",
                  background: "#99999c",
                  opacity: 0.25,
                }}
                className="flex-grow-1"
              />
            </Stack>
          </div>

          <div className="col-md-6 report_widget">
            <div className="fw-bold">
              <FormControlLabel
                control={
                  <CustomCheckbox
                    onChange={handleSelectAllWidget}
                    indeterminate={widgetPartialChecked()}
                    checked={widgets.length === reportWidgetName.length}
                  />
                }
                label="Choose the Report Widget Name"
                name="group1"
                className="m-0 column-gap-3"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontWeight: 700,
                    fontSize: 18,
                  },
                }}
              />
            </div>
            <hr />
            <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox
                  name="registered_user"
                  onChange={handleSelectWidget}
                  checked={widgets.includes("registered_user")}
                />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border">
                  <CardWithChart title="Registered User" />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6 className="m-0">
                  Users registered over the last six months.
                </h6>
              </div>
            </div>
            <hr />
            <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox
                  name="registered_company"
                  onChange={handleSelectWidget}
                  checked={widgets.includes("registered_company")}
                />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border">
                  <CardWithChartComp title={"Registered Companies"} />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6 className="m-0">View of Registered Companies.</h6>
              </div>
            </div>
            <hr />
            <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox
                  name="registered_kits"
                  onChange={handleSelectWidget}
                  checked={widgets.includes("registered_kits")}
                />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border">
                  <CardWithLineChart
                    style={{ fontSize: 20, fontWeight: 500 }}
                    className=""
                  />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6 className="m-0">
                  Annual View of Kits Registered over time.
                </h6>
              </div>
            </div>
            <hr />
            {/* <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border">
                  <CardWithMap title="Reported Incidents" />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6>View of Reported Incidents.</h6>
              </div>
            </div>
            <hr />
            <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border">
                  <StackedBarChart
                    count={DashboardListingData?.data?.incidentData}
                  />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6>Annual View of Number of Incidents.</h6>
              </div>
            </div>
            <hr /> */}
            <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox
                  name="safety_kit_installed"
                  onChange={handleSelectWidget}
                  checked={widgets.includes("safety_kit_installed")}
                />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border" style={{ padding: "20px" }}>
                  <KitInstalledChart />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6>Annual View of Number of Incidents.</h6>
              </div>
            </div>
            {/* <hr />
            <div className="row row-gap-3">
              <div className="col-12 col-sm-1">
                <CustomCheckbox />
              </div>
              <div className="col-12 col-sm-11 col-xl-8 col-xxl-7">
                <div className="border">
                  <CardWithMap title="Reported Incidents" />
                </div>
              </div>
              <div className="col-12 col-xl-3 col-xxl-4">
                <h6>View of Reported Incidents.</h6>
              </div>
            </div> */}
          </div>
        </div>
        <div
          className="position-sticky footer-section bg-white"
          style={{ zIndex: 1000 }}
        >
          <hr className="my-3" />
          <div className="row row-gap-3 align-items-center">
            <div className="col-12 col-sm-5 col-md-6">
              <div className="d-flex flex-wrap gap-3">
                <button className="user-mng-button" disabled>
                  <Stack direction="horizontal" className="gap-2">
                    <img src={DisableIcon} alt="DisableIcon" />
                    Disable
                  </Stack>
                </button>
                <button className="user-mng-button" type="button" disabled>
                  <Stack direction="horizontal" className="gap-2">
                    <img src={TrashIcon} alt="TrashIcon" />
                    Delete
                  </Stack>
                </button>
              </div>
            </div>
            <div className="col-12 col-sm-7 col-md-6">
              <div className="d-flex justify-content-end align-items-center flex-wrap-reverse gap-3">
                <NavLink
                  className="btn btn-dark flex-grow-1 flex-xxl-grow-0"
                  to="/reports"
                  type="button"
                >
                  Cancel
                </NavLink>
                <button
                  className="btn-primary btn p-auto px-xxl-5 flex-grow-1 flex-xxl-grow-0"
                  type="submit"
                >
                  {id ? "Update " : "Save "}Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Stack>
  );
};

export default ReportEditor;
